import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FormControl, TextField } from '@mui/material';
import dayjs from 'dayjs';

const CustomDatePicker = ({ value, onChange, autoFocus = false, id = "customDatePicker" }) => {
    return (
        <FormControl fullWidth size="small">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    id={id}
                    value={dayjs(value)}
                    onChange={onChange}
                    autoFocus={autoFocus}
                    format="DD-MMM-YYYY"
                    slotProps={{
                        textField: {
                            size: 'small',
                            variant: 'standard',
                            InputProps: {
                                disableUnderline: true,
                            },
                            sx: {
                                backgroundColor: 'transparent',
                                padding: 0,
                                '& .MuiInputBase-root': {
                                    border: 'none',
                                    paddingRight: '6px',
                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: '18px',
                                },
                            },
                        },
                    }}
                    renderInput={(props) => <TextField {...props} />}
                />
            </LocalizationProvider>
        </FormControl>
    );
};

export default CustomDatePicker;
